












import Vue from "vue";
import { authService } from "@/common/services/AuthService";
import { config } from "@/config";
import { navigationState } from "@/menu/components/NavigationState";
import { printState } from "@/common/state/PrintState";

export default Vue.extend({
  name: "TheAppBar",
  data() {
    return {
      config,
      authService: authService,
      navigationState,
      printState,
      filterOpen: false,
    };
  },
  methods: {
    toggleFilter(): void {
      this.filterOpen = !this.filterOpen;
    },
  },
});
